import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import StepLinkedFilesFormContainer from '../../../containers/portfolio/PortfolioFormContainers/StepLinkedFilesFormContainer.jsx';

const NewPortfolioStepLinkedFiles = ({ slug }) => (
  <>
    <Helmet>
      <title>New {getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <StepLinkedFilesFormContainer slug={slug} />
  </>
);

NewPortfolioStepLinkedFiles.getInitialProps = ({ query }) => ({
  portfolioId: Number(query.portfolioId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewPortfolioStepLinkedFiles));
